import { useImportMediaFiles } from 'hooks/useImportMediaFiles'
import { useQueryClient } from 'react-query'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useCurrentImageLibrary } from 'hooks/useCurrentImageLibrary'
import { ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'
import Styles from './BrandKitImages.module.scss'
import { Dropzone } from 'screens/Uploads/Dropzone/Dropzone'
import { Heading } from 'blaze-ui/Heading/Heading'
import cx from 'classnames'
import { Text } from 'blaze-ui/Text/Text'
import { AlmanacFile } from 'types'

export interface EmptyStateProps {
  brandKitId: number
  onSuccess?: (files: AlmanacFile[]) => void
  accept?: string
}

const DragOverlay = ({ isActive }: { isActive: boolean }) => (
  <div className={cx(Styles.dragOverlay, { [Styles.dragActive]: isActive })}>
    <Heading level={5} color="var(--light-100)">
      Drop your files here
    </Heading>
  </div>
)

export const EmptyState = ({
  brandKitId,
  onSuccess,
  accept = ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES,
}: EmptyStateProps) => {
  const workspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()
  const imageLibrary = useCurrentImageLibrary()

  const { uploadImageFiles } = useImportMediaFiles(false, (files) => {
    onSuccess?.(files)
    queryClient.invalidateQueries(['workspaces', workspaceId, 'brandKits', brandKitId, 'mediaFiles'])
    if (imageLibrary?.key) {
      queryClient.invalidateQueries(['workspace', workspaceId, 'files', imageLibrary.key])
    }
  })

  return (
    <div className={Styles.dropzoneContainer}>
      <Dropzone
        accept={accept}
        onDrop={(files) => {
          if (!files || !imageLibrary) return

          return uploadImageFiles(files, imageLibrary.key, { brand_kit_id: brandKitId })
        }}
        styles={Styles.dropzone}
        supportText="Blaze supports images and videos"
        buttonVariant="secondary"
        IconComponent={() => (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/v1744897958/blaze_assets/hd_icons/o3hfo5y4rutwqszg7f0q.png"
            alt=""
            width={112}
          />
        )}
        DragOverlayComponent={DragOverlay}
      >
        <div className={Styles.dropzoneContent}>
          <Text variant="secondary">Drop files here or</Text>
        </div>
      </Dropzone>
    </div>
  )
}
